import React, { ReactChildren, ReactNode } from 'react';
import styled from 'styled-components';

const MiniPopupSt = {
  ContBox: styled.div<{ left?: number; right?: number; top: number; width?: number; $arrowTop?: number }>`
    position: absolute;
    left: ${(p) => (p.left ? p.left + 'px' : 'auto')};
    right: ${(p) => (p.right ? p.right + 'px' : 'auto')};
    top: ${(p) => p.top + 'px'};
    width: ${(p) => (p.width ? p.width + 'px' : 'auto')};
    padding: 2px 0;
    border-radius: 14px;
    background: linear-gradient(to right, #0077a6, #00bea3);
    &:before {
      display: ${(p) => (p.$arrowTop ? 'block' : 'none')};
      position: absolute;
      ${(p) => (!!p.left ? 'right:' : 'left:')} calc(100% - 20px);
      top: ${(p) => (p.$arrowTop ? p.$arrowTop + 'px' : '10px')};
      content: '';
      width: 20px;
      height: 20px;
      background: #fff;
      border: 2px solid #0077a6;
      border-radius: 6px;
      transform: rotate(45deg) skew(-15deg, -15deg);
    }
  `,
  ContBg: styled.div`
    position: relative;
    z-index: 10;
    margin: 0 auto;
    width: calc(100% - 4px);
    border-radius: 12px;
    background: #fff;
  `,
  ContInner: styled.div<{ padding?: number[] }>`
    padding: ${(p) =>
      p.padding?.length === 1
        ? p.padding[0] + 'px'
        : p.padding?.length === 2
          ? `${p.padding[0]}px ${p.padding[1]}px ${p.padding[0]}px ${p.padding[1]}px`
          : p.padding?.length === 3
            ? `${p.padding[0]}px ${p.padding[1]}px ${p.padding[2]}px ${p.padding[1]}px`
            : p.padding?.length === 4
              ? `${p.padding[0]}px ${p.padding[1]}px ${p.padding[2]}px ${p.padding[3]}px`
              : '20px'};
  `,
};

interface MiniPopupProps {
  left?: number;
  right?: number;
  top: number;
  width?: number;
  children: ReactNode;
  $arrowTop?: number;
  padding?: number[];
}

const MiniPopup = ({ left, right, top, width, children, $arrowTop, padding }: MiniPopupProps) => {
  return (
    <MiniPopupSt.ContBox left={left} right={right} top={top} width={width} $arrowTop={$arrowTop}>
      <MiniPopupSt.ContBg>
        <MiniPopupSt.ContInner padding={padding}>{children}</MiniPopupSt.ContInner>
      </MiniPopupSt.ContBg>
    </MiniPopupSt.ContBox>
  );
};

export default MiniPopup;
